export const mentionRegExp = /(?:(^|[^a-zA-Z0-9_＠!@#$%&*]))((?:[@＠](?!\/))[a-z0-9/_.\-]{1,50})(?:\b(?![@＠])|$)/;

export const stringToColour = (str: string) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
    hash = hash & hash;
  }
  let color = (hash & 0x00ffffff).toString(16).toUpperCase();
  return "#" + "000000".substring(0, 6 - color.length) + color;
};
